export const exchangeTypes: any = {
  miss: 'Falta',
  off: 'Folga',
  switch: 'Troca',
  vacation: 'Férias',
}
